import React from "react"
import Popup from "component/popup/popup"
import IconsColor from "util/iconsColor"
import InputText from "component/inputText/inputText"
import SecretField from "./secretField"
import { ConfigurationUser, loginIdentifier } from "./configurationUsers"
import styles from "./configuration.module.scss"

type PasswordUpdatedPopupProps = {
    isOpen: boolean
    user: ConfigurationUser | null
    newPassword: string
    onClose: () => void
    onCopy: (text: string, message: string) => void
}

const PasswordUpdatedPopup: React.FC<PasswordUpdatedPopupProps> = ({
    isOpen,
    user,
    newPassword,
    onClose,
    onCopy,
}) => {
    const identifier = user ? loginIdentifier(user) : ""
    const identifierLabel = user?.username_type === "phone" ? "Phone Number" : "Email ID"

    return (
        <Popup
            isOpen={isOpen}
            onClose={onClose}
            title="Password Updated Successfully"
            size="medium"
            showCloseButton={false}
            titleClassName={styles.successTitle}
        >
            <div className={styles.successWrap}>
                <div className={styles.successIcon}>
                    <IconsColor iconName="checkIcon" width="24" height="24" fillColor="none" strokeColor="currentColor" />
                </div>
                <div className={styles.credentialCard}>
                    <div>
                        <div className={styles.credentialLabel}>{identifierLabel}</div>
                        <div className={styles.secretWrap}>
                            <InputText
                                label={identifierLabel}
                                hideLabel
                                value={identifier}
                                onChange={() => undefined}
                                disabled
                                noMargin
                                sx={{ paddingRight: "44px" }}
                            />
                            <div className={styles.secretActions} style={{ top: 8 }}>
                                <button
                                    type="button"
                                    className={styles.secretIconBtn}
                                    onClick={() => onCopy(identifier, "Copied")}
                                    aria-label="Copy identifier"
                                >
                                    <IconsColor iconName="copyIcon" width="18" height="18" fillColor="none" strokeColor="currentColor" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={styles.credentialLabel}>NEW PASSWORD</div>
                        <SecretField
                            label="New password"
                            hideLabel
                            value={newPassword}
                            readOnly
                            showCopy
                            onCopy={() => onCopy(newPassword, "Password copied")}
                        />
                    </div>
                    <button
                        type="button"
                        className={styles.copyAllBtn}
                        onClick={() => onCopy(`${identifier}\n${newPassword}`, "Credentials copied")}
                    >
                        <IconsColor iconName="copyIcon" width="16" height="16" fillColor="none" strokeColor="#ffffff" />
                        Copy All Credentials
                    </button>
                </div>
                <p className={styles.shareNote}>Share these credentials with the user securely.</p>
                <button type="button" className={styles.closeBtn} onClick={onClose}>
                    Close
                </button>
            </div>
        </Popup>
    )
}

export default PasswordUpdatedPopup
